import { captureException as sentryCaptureException } from '@sentry/react';

import { CircleTopicFormat } from 'src/generated/graphql';
import { captureException } from 'src/shared/utils/captureException';

// Takes a raw Circle topic format and returns the translation key for the string
export function formatCircleFormat(circleFormat: CircleTopicFormat | string): string {
  switch (circleFormat) {
    case CircleTopicFormat.Discussion:
      return 'Discussion';
    case CircleTopicFormat.Fireside:
      return 'Fireside';
    case CircleTopicFormat.ListenAndLearn:
      return 'Listen and Learn';
    case CircleTopicFormat.Workshop:
      return 'Workshop';
    default:
      sentryCaptureException(new Error(`Unhandled Circle format ${circleFormat}`));
      captureException(new Error(`Unhandled Circle format ${circleFormat}`));
      return circleFormat.split('-').join(' ').toLowerCase();
  }
}
